// extracted by mini-css-extract-plugin
export var compactFilters = "_e6-4";
export var detailImage = "_e6-1";
export var dropdownContainer = "_e6-2";
export var imageContainer = "_e6-0";
export var selectedCard = "_e6-3";